//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehiclePropValueRequest.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { StatusCode } from "./StatusCode_pb";
import { file_android_hardware_automotive_vehicle_StatusCode } from "./StatusCode_pb";
import type { VehiclePropValue } from "./VehiclePropValue_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropValue } from "./VehiclePropValue_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/VehiclePropValueRequest.proto.
 */
export const file_android_hardware_automotive_vehicle_VehiclePropValueRequest: GenFile = /*@__PURE__*/
  fileDesc("CkFhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlUHJvcFZhbHVlUmVxdWVzdC5wcm90bxIpYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8ieQoXVmVoaWNsZVByb3BWYWx1ZVJlcXVlc3QSEgoKcmVxdWVzdF9pZBgBIAEoAxJKCgV2YWx1ZRgCIAEoCzI7LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlZlaGljbGVQcm9wVmFsdWUiTQoXVXBkYXRlU2FtcGxlUmF0ZVJlcXVlc3QSDAoEcHJvcBgBIAEoBRIPCgdhcmVhX2lkGAIgASgFEhMKC3NhbXBsZV9yYXRlGAMgASgCImsKDlNldFZhbHVlUmVzdWx0EhIKCnJlcXVlc3RfaWQYASABKAMSRQoGc3RhdHVzGAIgASgOMjUuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uU3RhdHVzQ29kZSK3AQoOR2V0VmFsdWVSZXN1bHQSEgoKcmVxdWVzdF9pZBgBIAEoAxJFCgZzdGF0dXMYAiABKA4yNS5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5TdGF0dXNDb2RlEkoKBXZhbHVlGAMgASgLMjsuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uVmVoaWNsZVByb3BWYWx1ZSJwChhWZWhpY2xlUHJvcFZhbHVlUmVxdWVzdHMSVAoIcmVxdWVzdHMYASADKAsyQi5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5WZWhpY2xlUHJvcFZhbHVlUmVxdWVzdCJdCg9TZXRWYWx1ZVJlc3VsdHMSSgoHcmVzdWx0cxgBIAMoCzI5LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlNldFZhbHVlUmVzdWx0Il0KD0dldFZhbHVlUmVzdWx0cxJKCgdyZXN1bHRzGAEgAygLMjkuYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8uR2V0VmFsdWVSZXN1bHRiBnByb3RvMw", [file_android_hardware_automotive_vehicle_StatusCode, file_android_hardware_automotive_vehicle_VehiclePropValue]);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.VehiclePropValueRequest
 */
export type VehiclePropValueRequest = Message<"android.hardware.automotive.vehicle.proto.VehiclePropValueRequest"> & {
  /**
   * @generated from field: int64 request_id = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.VehiclePropValue value = 2;
   */
  value?: VehiclePropValue;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehiclePropValueRequest.
 * Use `create(VehiclePropValueRequestSchema)` to create a new message.
 */
export const VehiclePropValueRequestSchema: GenMessage<VehiclePropValueRequest> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 0);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.UpdateSampleRateRequest
 */
export type UpdateSampleRateRequest = Message<"android.hardware.automotive.vehicle.proto.UpdateSampleRateRequest"> & {
  /**
   * Property identifier 
   *
   * @generated from field: int32 prop = 1;
   */
  prop: number;

  /**
   * Area type(s) for non-global property it must be one of the value from
   * VehicleArea* enums or 0 for global properties. 
   *
   * @generated from field: int32 area_id = 2;
   */
  areaId: number;

  /**
   * @generated from field: float sample_rate = 3;
   */
  sampleRate: number;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.UpdateSampleRateRequest.
 * Use `create(UpdateSampleRateRequestSchema)` to create a new message.
 */
export const UpdateSampleRateRequestSchema: GenMessage<UpdateSampleRateRequest> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 1);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.SetValueResult
 */
export type SetValueResult = Message<"android.hardware.automotive.vehicle.proto.SetValueResult"> & {
  /**
   * @generated from field: int64 request_id = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.StatusCode status = 2;
   */
  status: StatusCode;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.SetValueResult.
 * Use `create(SetValueResultSchema)` to create a new message.
 */
export const SetValueResultSchema: GenMessage<SetValueResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 2);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.GetValueResult
 */
export type GetValueResult = Message<"android.hardware.automotive.vehicle.proto.GetValueResult"> & {
  /**
   * @generated from field: int64 request_id = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.StatusCode status = 2;
   */
  status: StatusCode;

  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.VehiclePropValue value = 3;
   */
  value?: VehiclePropValue;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.GetValueResult.
 * Use `create(GetValueResultSchema)` to create a new message.
 */
export const GetValueResultSchema: GenMessage<GetValueResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 3);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.VehiclePropValueRequests
 */
export type VehiclePropValueRequests = Message<"android.hardware.automotive.vehicle.proto.VehiclePropValueRequests"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.VehiclePropValueRequest requests = 1;
   */
  requests: VehiclePropValueRequest[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehiclePropValueRequests.
 * Use `create(VehiclePropValueRequestsSchema)` to create a new message.
 */
export const VehiclePropValueRequestsSchema: GenMessage<VehiclePropValueRequests> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 4);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.SetValueResults
 */
export type SetValueResults = Message<"android.hardware.automotive.vehicle.proto.SetValueResults"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.SetValueResult results = 1;
   */
  results: SetValueResult[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.SetValueResults.
 * Use `create(SetValueResultsSchema)` to create a new message.
 */
export const SetValueResultsSchema: GenMessage<SetValueResults> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 5);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.GetValueResults
 */
export type GetValueResults = Message<"android.hardware.automotive.vehicle.proto.GetValueResults"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.GetValueResult results = 1;
   */
  results: GetValueResult[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.GetValueResults.
 * Use `create(GetValueResultsSchema)` to create a new message.
 */
export const GetValueResultsSchema: GenMessage<GetValueResults> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehiclePropValueRequest, 6);

